export type Port = {
  id: string;
  name: string;
  state: string;
  x: number;
  y: number;
  fish: string[];
  description: string;
  image?: string;
};

export const hub = {
  name: 'Bengaluru',
  x: 35,
  y: 79,
};

const ports: Port[] = [
  {
    id: 'kolkata',
    name: 'Kolkata (Haldia)',
    state: 'West Bengal',
    x: 69,
    y: 50,
    fish: ['Hilsa', 'Tiger prawn', 'Bhetki'],
    description:
      'Haldia jetty supply with chilled trucks feeding east and north-east urban demand daily.',
  },
  {
    id: 'veraval',
    name: 'Veraval',
    state: 'Gujarat',
    x: 6,
    y: 49,
    fish: ['Pomfret', 'King mackerel', 'Prawns'],
    description:
      'High-volume landings from the Arabian Sea with blast-freeze capacity for fast north-west dispatches.',
  },
  {
    id: 'mumbai',
    name: 'Mumbai',
    state: 'Maharashtra',
    x: 16,
    y: 62,
    fish: ['Bombay duck', 'Seer fish', 'Squid'],
    description:
      'Auction-led sourcing synced with night runs to our reefer fleet, balancing price and freshness windows.',
  },
  {
    id: 'goa',
    name: 'Mormugao (Goa)',
    state: 'Goa',
    x: 19,
    y: 74,
    fish: ['Snapper', 'Tuna', 'Ribbon fish'],
    description:
      'Port close to on-site ice plants; ideal for consistent whitefish supply into western metros.',
  },
  {
    id: 'mangalore',
    name: 'Mangalore',
    state: 'Karnataka',
    x: 22,
    y: 80,
    fish: ['Seer fish', 'Prawns', 'Crab'],
    description:
      'Fuel-efficient turnaround into Bengaluru with quality checks within four hours of landing.',
  },
  {
    id: 'kochi',
    name: 'Kochi',
    state: 'Kerala',
    x: 28,
    y: 91,
    fish: ['Pearl spot', 'Tiger prawn', 'Anchovy'],
    description:
      'Backwater hubs plus auction integration give predictable lots for fillet and chilled trays.',
  },
  {
    id: 'tuticorin',
    name: 'Tuticorin',
    state: 'Tamil Nadu',
    x: 34,
    y: 94,
    fish: ['Yellowfin tuna', 'Cuttlefish', 'Lobster'],
    description:
      'Deep-sea trawler tie-ups and container access make it our long-haul export-quality stream.',
  },
  {
    id: 'chennai',
    name: 'Chennai',
    state: 'Tamil Nadu',
    x: 41,
    y: 81,
    fish: ['Seer fish', 'Barracuda', 'Prawns'],
    description:
      'Night harvests routed through our cold cross-dock before morning city fulfilment drops.',
  },
  {
    id: 'kakinada',
    name: 'Kakinada',
    state: 'Andhra Pradesh',
    x: 49,
    y: 68,
    fish: ['Vannamei shrimp', 'Croaker', 'Clams'],
    description:
      'Shrimp-dominant port; live ice slurry and ATP monitoring keep export-grade specs intact.',
  },
  {
    id: 'vizag',
    name: 'Visakhapatnam',
    state: 'Andhra Pradesh',
    x: 53,
    y: 65,
    fish: ['Mahi mahi', 'Red snapper', 'Squid'],
    description: 'Eastern fleet berth with container rail options for fast east-to-north transits.',
  },
  {
    id: 'paradip',
    name: 'Paradip',
    state: 'Odisha',
    x: 64,
    y: 56,
    fish: ['Hilsa', 'Pomfret', 'Prawns'],
    description:
      'River-sea interface allows diverse species; rapid QC prevents freshwater spoilage creep.',
  },
];

export default ports;
